/**
 * Formate une durée en millisecondes en texte lisible ("12 s", "3 min 05 s").
 * Purement présentationnel : ne dépend d'aucune règle métier.
 */
export function formatDuree(ms) {
  if (ms === null || ms === undefined) {
    return "-";
  }
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes === 0) {
    return `${seconds} s`;
  }
  return `${minutes} min ${String(seconds).padStart(2, "0")} s`;
}
